module.exports = __webpack_public_path__ + "static/media/clock.bda32b20.svg";